import React from 'react';
import { IonButton, IonIcon, IonSpinner } from '@ionic/react';

export interface ModalFooterProps {
  cancelLabel?: string;
  actionLabel?: string;
  onCancel: () => void;
  onAction: () => void;
  isCancelDisabled?: boolean;
  isActionDisabled?: boolean;
  isActionLoading?: boolean;
  cancelFill?: 'clear' | 'solid' | 'outline' | 'default';
  actionFill?: 'clear' | 'solid' | 'outline' | 'default';
  actionColor?: 'primary' | 'danger' | 'success' | 'medium' | 'tertiary';
  cancelIcon?: string;
  actionIcon?: string;
  secondaryAction?: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    color?: 'primary' | 'danger' | 'success' | 'medium' | 'tertiary';
    icon?: string;
  };
  hideCancel?: boolean;
  hideAction?: boolean;
}

const ModalFooter: React.FC<ModalFooterProps> = ({
  cancelLabel = 'Cancel',
  actionLabel = 'Action',
  cancelIcon,
  onCancel,
  onAction,
  isCancelDisabled = false,
  isActionDisabled = false,
  isActionLoading = false,
  cancelFill = 'clear',
  actionFill = 'solid',
  actionColor = 'primary',
  actionIcon,
  secondaryAction,
  hideCancel = false,
  hideAction = false,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '1rem',
        padding: '1rem',
        background: 'var(--ion-color-light-tint)',
        borderTop: '1px solid var(--ion-color-light-shade)',
      }}
    >
      {!hideCancel && (
        <IonButton fill={cancelFill} onClick={onCancel} disabled={isCancelDisabled}>
          {cancelIcon && <IonIcon icon={cancelIcon} slot="start" />}
          {cancelLabel}
        </IonButton>
      )}

      {secondaryAction && (
        <IonButton
          color={secondaryAction.color ?? 'primary'}
          fill="solid"
          onClick={secondaryAction.onClick}
          disabled={secondaryAction.disabled}
        >
          {secondaryAction.icon && <IonIcon icon={secondaryAction.icon} slot="start" />}
          {secondaryAction.label}
        </IonButton>
      )}

      {!hideAction && (
        <IonButton
          color={actionColor}
          fill={actionFill}
          onClick={onAction}
          disabled={isActionDisabled || isActionLoading}
        >
          {isActionLoading ? (
            <>
              <IonSpinner name="crescent" />
              <span style={{ marginLeft: '8px' }}>{actionLabel}</span>
            </>
          ) : (
            <>
              {actionIcon && <IonIcon icon={actionIcon} slot="start" />}
              {actionLabel}
            </>
          )}
        </IonButton>
      )}
    </div>
  );
};

export default ModalFooter;
